import {areEqual, isEmptyOrNull, isNotEmptyOrNull, substringBefore} from "../../common/NamaCommon";
import {getAllInnerStrings} from "../../common/StringUtils";
import {JSCriteriaBuilder} from "../../common/JSCriteriaBuilder";

export function getValueOf(ref, criteria) {
    if (isEmptyOrNull(criteria) || isEmptyOrNull(criteria.expressions))
        return "";
    for (let expression of criteria.expressions) {
        if (areEqual(expression.field, ref))
            return expression.rightHandSide;
    }
    return "";
}

export function defaultCriteriaForFilterField(field, filteredType, valueCalculator) {
    if (!field)
        return null;

    let expressions = criteriaStrToMap(field.criteriaExpression);
    let strExpression = expressions.get(filteredType);
    if (strExpression == null)
        strExpression = expressions.get("");
    if (isEmptyOrNull(strExpression))
        return null;
    let referencesToOtherFields = getAllInnerStrings(strExpression, "${", "}");
    for (let ref of referencesToOtherFields) {
        strExpression = strExpression.replace("${" + ref + "}", valueCalculator(ref));
    }
    return JSCriteriaBuilder.criteriaFromStr(strExpression);
}

function criteriaStrToMap(crt) {
    let map = new Map();
    if (!crt)
        return map;
    if (!crt.trim().startsWith("#")) {
        map.set("", crt);
    } else {
        while (isNotEmptyOrNull(crt)) {
            crt = crt.trim().substring(1);
            let entityType = substringBefore(crt, "{");
            crt = crt.substring(entityType.length + 1);
            let expression = substringBefore(crt, "#");
            if (expression.length > 0)
                expression = expression.substring(0, expression.length - 1);
            crt = crt.substring(expression.length + 1);
            map.set(entityType, expression);
        }
    }
    return map;
}